<template>
    <div v-if="loading" class="loader center s">
      <loading-circle />
    </div>
    <div class="forecast" v-else>
      <div class="forecast-header v-center px-3 space-between">
        <h1 class="weight-500 xxl">Resource Trends</h1>
        <span v-if="isOnProjectLevel">
            <span class="mx-3">
                <router-link
          :to="'/trendsandforecast/material-forecast'"
          >
          <button
            class="toggle toggle-left pointer "
          >
            Forecast
          </button>
        </router-link>
            <button
            class="toggle toggle-right pointer toggle-selected "
          >
            Trends
          </button>
        </span>

          <button class="btn "  v-if="materialData" @click="exportToCsv">Export CSV</button>
        </span>
      </div>
      <div class="forecast-filters">
        <div>Filters</div>
        <div class="space-between">
          <div class="flex gap-1  flex-wrap">
            <div class="date-range">
              <span>From:</span>
              <input
                type="date"
                class="ml-3"
                v-model="filters.from"
                @change="dateValidation"
              />
              <span class="ml-3">Upto:</span>
              <input
                type="date"
                class="ml-3"
                v-model="filters.upto"
                @change="applyButton = false"
                :min="filters.from"
              />
            </div>
            <button class="btn" :disabled="applyButton" @click="applyFilters">
              Apply
            </button>
          </div>

          <div></div>
        </div>
      </div>
      <div v-if="!selectedMaterial" class="forecast-empty h-center v-center mt-5">
  <h4>No resouce  has been used in the given period</h4>
    </div>
      <div class="forecast-container"  v-else>
        <div class="forecast-container-table" v-if="materialData">
          <table>
          <thead>
            <tr>
              <th>Sl.No</th>
              <th>Resource ID</th>
              <th>Resource Name</th>
              <!-- <th>Actual</th>
              <th>Planned </th> -->
            </tr>
          </thead>
          <tbody>
            <tr v-for="(resource,index) in Object.values(resourceMap)" :key="resource.id" @click="setupChartView(resource.id,resource?.material_name)" :class="{'selectedMaterial':selectedMaterial===resource.id}">
              <td>{{  index+1 || '--' }}</td>
              <td>{{  resource?.custom_material_id || '--' }}</td>
              <td>{{  resource?.material_name || '--' }}</td>
              <!-- <td>{{ resource?.inventory || '--'  }}</td>
              <td>{{  resource.quantity || '--' }}</td> -->
            </tr>
          </tbody>
        </table>
      </div>
        <i v-else>no materials are available...</i>
        <div class="forecast-container-graph px-2 v-center h-center">
          <div  v-if="chartLoading">

          </div>
      <div v-else-if="selectedMaterial" class="hw-100 column v-center">
        <label> {{ resourceMap[selectedMaterial].material_name }}</label>
        <apexchart
        v-if="series.length === 2"
        class="lineCharts-single"
        type="line"
        :options="chartOptions"
        :series="series"
        >
        </apexchart>
        <apexchart
        class="lineCharts-single"
        type="line"
        :options="statusChartOptions"
        :series="statusSeries"
        >
        </apexchart>
      </div>

        </div>
      </div>
    </div>
  </template>

<script>
/* eslint-disable no-unmodified-loop-condition */
// import MultiselectDropdown from '../../components/common/multiselectDropdown.vue'
import { mapGetters } from 'vuex'
import { getResourceTrendsData, GetProjectAssocResources, getResourceStatusData } from '@/api'
import loadingCircle from '../../components/common/loadingCircle.vue'
import { arrayToCsv } from '@/helper/file/arrayToCsv'
import { getDayDifference, getWeeksInRangeFormatted, getWeekNumber } from '@/utils/date'
import { alert } from '@/plugins/notification'

export default {
  name: 'MaterialForecast',
  components: {
    // MultiselectDropdown,
    loadingCircle
  },
  methods: {
    applyFilters () {
      try {
        this.series = []
        this.statusSeries = []
        this.appliedFilters = this.filters
        let plannedChartSeries = []
        let actualChartSeries = []
        this.loading = true
        const days = getDayDifference(this.appliedFilters.from, this.appliedFilters.upto)
        if (days >= 60) {
          this.selectedType = 'year'
        } else if (days >= 7) {
          this.selectedType = 'week'
        } else {
          this.selectedType = 'day'
        }
        const body = {
          resourceId: this.selectedMaterial,
          startDate: this.appliedFilters.from,
          endDate: this.appliedFilters.upto,
          filterBy: this.selectedType
        }
        Promise.all([getResourceTrendsData(body), getResourceStatusData(body)]).then(([res, statusData]) => {
          const dates = this.generateDatesInRange(
            new Date(this.appliedFilters.from),
            new Date(this.appliedFilters.upto)
          )
          const resourceStatusData = {}
          const numberOfDates = Object.values(dates).length
          statusData.message.forEach((resource) => {
            if (resourceStatusData[resource.state_value]) {
              resourceStatusData[resource.state_value][dates[resource.date]] = Math.round(resource.hours)
            } else {
              resourceStatusData[resource.state_value] = new Array(numberOfDates).fill(0)
              resourceStatusData[resource.state_value][dates[resource.date]] = Math.round(resource.hours)
            }
          })
          for (const [key, value] of Object.entries(resourceStatusData)) {
            this.statusSeries.push({
              name: key,
              data: value
            })
          }
          if (this.selectedType === 'day') {
            plannedChartSeries = new Array(Object.values(dates).length).fill(0)
            actualChartSeries = new Array(Object.values(dates).length).fill(0)
            res.message.planned.forEach((resource) => {
              const fromatedDate = new Date(resource.date).toISOString().split('T')[0]
              if (dates[fromatedDate]) {
                plannedChartSeries[dates[fromatedDate]] = resource.sum
              }
            })
            res.message.actual.forEach((resource) => {
              const fromatedDate = new Date(resource.date).toISOString().split('T')[0]
              if (dates[fromatedDate]) {
                actualChartSeries[dates[fromatedDate]] = resource.sum
              }
            })
            this.chartOptions.labels = [...this.chartOptions.labels]
            this.chartOptions.xaxis = {
              type: 'datetime'
            }
            this.series = [{
              name: 'Actual',
              type: 'column',
              data: actualChartSeries
              // data: [2, 3, 4]
            }, {
              name: 'Planned',
              type: 'area',
              data: plannedChartSeries
              // data: [5, 6, 7]
            }]
          } else if (this.selectedType === 'year') {
            const firstYear = Math.min(new Date(res.message?.planned?.[0]?.date)?.getFullYear() || new Date(res.message?.actual?.[0]?.date).getFullYear(), new Date(res.message?.actual?.[0]?.date).getFullYear() || new Date(res.message?.planned?.[0]?.date)?.getFullYear())
            const lastYear = Math.max(new Date(res.message?.planned?.at(-1)?.date).getFullYear() || new Date(res.message?.actual?.at(-1)?.date).getFullYear(), new Date(res.message?.actual?.at(-1)?.date).getFullYear() || new Date(res.message?.planned?.at(-1)?.date).getFullYear())
            const months = [
              'Jan',
              'Feb',
              'Mar',
              'Apr',
              'May',
              'Jun',
              'Jul',
              'Aug',
              'Sep',
              'Oct',
              'Nov',
              'Dec'
            ]
            const monthMap = {
              0: 'Jan',
              1: 'Feb',
              2: 'Mar',
              3: 'Apr',
              4: 'May',
              5: 'Jun',
              6: 'Jul',
              7: 'Aug',
              8: 'Sep',
              9: 'Oct',
              10: 'Nov',
              11: 'Dec'
            }
            let years = []
            if (!firstYear || !lastYear) {
              this.loading = false
              alert('No data is available')
              return
            }
            if (lastYear - firstYear > 0) {
              let currentYear = firstYear
              while (currentYear <= lastYear) {
                years.push(currentYear)
                currentYear++
              }
            } else {
              years = [firstYear ?? lastYear]
            }
            const chartLabel = []
            for (const year of years) {
              for (const month of months) {
                chartLabel.push(`${month}-${String(year).substring(2)}`)
              }
            }
            plannedChartSeries = new Array(chartLabel.length).fill(0)
            actualChartSeries = new Array(chartLabel.length).fill(0)
            res.message.planned.forEach((resource) => {
              const month = new Date(resource.date).getMonth()
              const yearstring = String(new Date(resource.date).getFullYear()).substring(2)
              const monthIndex = chartLabel.findIndex(item => item === `${monthMap[month]}-${yearstring}`)
              if (monthIndex !== -1) {
                plannedChartSeries[monthIndex] = resource.sum ?? 0
              }
            })
            res.message.actual.forEach((resource) => {
              const month = new Date(resource.date).getMonth()
              const yearstring = String(new Date(resource.date).getFullYear()).substring(2)
              const monthIndex = chartLabel.findIndex(item => item === `${monthMap[month]}-${yearstring}`)
              if (monthIndex !== -1) {
                actualChartSeries[monthIndex] = resource.sum ?? 0
              }
            })
            this.chartOptions.xaxis = {
              type: 'category',
              categories: [...chartLabel]
            }
            this.series = [{
              name: 'Actual',
              type: 'column',
              data: actualChartSeries
              // data: [2, 3, 4]
            }, {
              name: 'Planned',
              type: 'area',
              data: plannedChartSeries
              // data: [5, 6, 7]
            }]
          } else if (this.selectedType === 'week') {
            const weekMap = getWeeksInRangeFormatted(
              new Date(this.appliedFilters.from),
              new Date(this.appliedFilters.upto)
            )
            const weekNumbers = Object.keys(weekMap)
            plannedChartSeries = new Array(Object.keys(weekMap).length).fill(0)
            actualChartSeries = new Array(Object.keys(weekMap).length).fill(0)
            res.message.planned.forEach((resource) => {
              const weekIndex = getWeekNumber(new Date(resource.date))
              const index = weekNumbers.findIndex(item => Number(item) === weekIndex)
              if (index !== -1) {
                plannedChartSeries[index] = resource.sum
              }
            })
            res.message.actual.forEach((resource) => {
              const weekIndex = getWeekNumber(new Date(resource.date))
              const index = weekNumbers.findIndex(item => Number(item) === weekIndex)
              if (index !== -1) {
                plannedChartSeries[index] = resource.sum
              }
            })
            this.chartOptions.xaxis = {
              type: 'category',
              categories: Object.values(weekMap)
            }
            this.series = [{
              name: 'Actual',
              type: 'column',
              data: actualChartSeries
              // data: [2, 3, 4]
            }, {
              name: 'Planned',
              type: 'area',
              data: plannedChartSeries
              // data: [5, 6, 7]
            }]
          }

          this.loading = false
        })
      } catch (error) {
        this.loading = false
      }
    },
    getOneMonthAfterDate (currentDate) {
      const oneMonthAfter = new Date(currentDate)
      oneMonthAfter.setMonth(oneMonthAfter.getMonth() + 1)
      return this.formatDate(oneMonthAfter)
    },
    generateDatesInRange (startDate, endDate) {
      const dates = {}
      const xAxis = []
      this.statusChartOptions.xaxis.categories = []
      const options = {
        year: '2-digit',
        month: '2-digit',
        day: '2-digit'
      }
      this.chartOptions.labels = []
      const currentDate = new Date(startDate)
      let i = 0
      while (currentDate <= endDate) {
        dates[new Date(currentDate).toISOString().split('T')[0]] = i
        xAxis.push(new Date(currentDate).toISOString())
        this.statusChartOptions.xaxis.categories.push(currentDate.toLocaleString('en-GB', options))
        currentDate.setDate(currentDate.getDate() + 1)
        i++
      }
      this.chartOptions.labels = xAxis
      return dates
    },
    formatDate (date) {
      const year = date.getFullYear()
      const month = String(date.getMonth() + 1).padStart(2, '0')
      const day = String(date.getDate()).padStart(2, '0')
      return `${year}-${month}-${day}`
    },
    setInitialDates () {
      const currentDate = new Date()
      const currentFormattedDate = this.formatDate(currentDate)
      const oneMonthAfterFormattedDate =
          this.getOneMonthAfterDate(currentDate)
      this.filters.from = currentFormattedDate
      this.filters.upto = oneMonthAfterFormattedDate
    },
    setupChartView (materialId, materialName) {
      this.selectedMaterial = materialId
      this.applyFilters()
      if (materialId) {
        return
      }
      this.chartLoading = true
      this.materialSeries = [{ name: 'Forecasted Qty', data: [] }, { name: 'Current Inventory', data: [] }, { name: 'Projected Inventory', data: [] }]
      this.chartOptions.xaxis.categories = []
      const dates = this.generateDatesInRange(
        new Date(this.appliedFilters.from),
        new Date(this.appliedFilters.upto)
      )
      const numberOfDates = Object.keys(dates).length
      this.materialSeries[0].data = new Array(
        numberOfDates
      ).fill(0)
      this.materialSeries[1].data = new Array(
        numberOfDates
      ).fill(this.materialData[this.selectedMaterial].inventory ?? 0)
      this.chartLoading = false
    },
    exportToCsv () {
      try {
        const materialCsv = []
        let projectNames = ''
        let MaterialGroupNames = ''
        for (const resource of Object.values(this.resourceMap)) {
          resource['Material ID'] = resource.custom_material_id
          resource['Material Name'] = resource.material_name
          materialCsv.push(resource)
        }
        if (this.appliedFilters.projectIds.length > 0) {
          for (let i = 0; i < this.appliedFilters.projectIds.length; i++) {
            for (let j = 0; j < this.projects.length; j++) {
              if (this.appliedFilters.projectIds[i] === this.projects[j].value) {
                projectNames = projectNames + this.projects[j]?.label + ',   '
                break
              }
            }
          }
        } else {
          this.projects.forEach((project) => {
            projectNames = projectNames + project?.label + ',  '
          })
        }

        if (this.appliedFilters.materialGroupIds.length > 0) {
          for (let i = 0; i < this.appliedFilters.materialGroupIds.length; i++) {
            for (let j = 0; j < this.list_of_material_group.length; j++) {
              if (parseInt(this.appliedFilters.materialGroupIds[i]) === parseInt(this.list_of_material_group[j].value)) {
                MaterialGroupNames = MaterialGroupNames + this.list_of_material_group[j]?.label + ',  '
                break
              }
            }
          }
        } else {
          this.list_of_material_group.forEach((materialGrp) => {
            MaterialGroupNames = MaterialGroupNames + materialGrp?.label + ',  '
          })
        }
        arrayToCsv(
          materialCsv,
          ['id', '__typename', 'material_id', 'required_date', 'material_name', 'product_code', 'quantity', 'unit_of_material', 'custom_material_id'],
          'material-forecast-data.csv', { To: this.chartOptions.xaxis.categories.at(-1), from: this.chartOptions.xaxis.categories[0], Material_Group: MaterialGroupNames, Projects: projectNames }
        )
      } catch (err) {
        console.log(err)
      }
    },
    dateValidation (e) {
      this.applyButton = false
      if ((new Date(e.target.value) < new Date(this.filters?.upto)) && this.filters.upto) {
      } else {
        this.filters.upto = new Date(e.target.value).toISOString().split('T')[0]
      }
    },
    getResourceList () {
      GetProjectAssocResources([this.openProjectId], 'project').then(res => {
        res.core_material_master.forEach(item => {
          this.resourceMap[item.id] = item
        })
        this.selectedMaterial = Object.values(this.resourceMap)[0].id
        this.applyFilters()
      })
    }
  },
  data () {
    return {
      list_of_material_group: [],
      applyButton: true,
      materialSeries: [],
      chartLoading: false,
      materialData: {}, // contains materials list after calculating total quantity
      selectedMaterial: null, // contains all material data without adding quatity of same materials
      filters: {
        from: '',
        upto: '',
        projectIds: [],
        materialGroupIds: []
      },
      appliedFilters: {
        projectIds: [],
        materialGroupIds: []
      },
      loading: false,
      resourceMap: {},
      selectedType: 'day',
      projects: [],
      projectSeries: [],
      series: [],
      chartOptions: {
        chart: {
          type: 'line',
          stacked: false,
          zoom: {
            enabled: true
          }
        },
        stroke: {
          width: [0, 2],
          curve: 'smooth'
        },
        plotOptions: {
          bar: {
            columnWidth: '30%'
          }
        },

        fill: {
          opacity: [0.85, 0.25, 1],
          gradient: {
            inverseColors: false,
            shade: 'light',
            type: 'vertical',
            opacityFrom: 0.85,
            opacityTo: 0.55,
            stops: [0, 100, 100, 100]
          }
        },
        markers: {
          size: 0
        },
        labels: [],
        xaxis: {
          type: 'category',
          categories: []
        },
        yaxis: {
          min: 0
        },
        tooltip: {
          shared: true,
          intersect: false,
          y: {
            formatter: function (y) {
              if (typeof y !== 'undefined') {
                return y.toFixed(0) + ' Materials'
              }
              return y
            }
          }
        }
      },
      statusSeries: [],
      statusChartOptions: {
        chart: {
          height: 350,
          type: 'line',
          zoom: {
            enabled: true
          }
        },
        dataLabels: {
          enabled: false
        },
        stroke: {
          curve: 'straight'
        },
        title: {
          text: '',
          align: 'left'
        },
        grid: {
          row: {
            colors: ['#f3f3f3', 'transparent'], // takes an array which will be repeated on columns
            opacity: 0.5
          }
        },
        xaxis: {
          categories: []
        }
      }
    }
  },
  computed: {
    ...mapGetters(['user', 'getUserById', 'isOnProjectLevel', 'openProjectId']),
    ...mapGetters(['tenantUsersList', 'tenantProjectList'])
  },
  mounted () {
    this.setInitialDates()
    this.getResourceList()
    // this.applyFilters()
  },
  watch: {

  }
}

</script>

  <style lang="scss">
  .forecast {
    position: relative;
    height: calc(100vh - 84px);
    &-header {
      height: 60px;
      margin: -12px;
      margin-bottom: 0;
      background: var(--bg-color);
      border-bottom: var(--border);
    }
    &-filters {
      margin: 4px;
      margin-top: 1rem;
      padding: 10px;
      border: var(--border);
      position: sticky;
      top: 0px;
      z-index: 6;
      background-color: white;
    }
    &-container {
      height: calc(100% - 127px);
      display: grid;
      grid-template-columns: 1fr 1fr;
      column-gap: 1rem;
      padding: 1rem;
      &-table{
        overflow: auto;
        height: calc(100vh - 260px);
        table {
        width: 100%;
        position: relative;
        border-collapse: collapse;

        th {
          position: sticky;
          width:auto;
          top: 0px;
          font-weight: 500;
          background-color: var(--brand-color);
        }
        tr{
          z-index: 0;
        }
        th,
        td {
          text-align: left;
          font-size: var(--text-s);
          padding: 8px 4px;
        }
        tr:nth-child(odd) {
          background-color: rgba(var(--brand-rgb), 0.05);
          border: 1px solid var(--brand-color);
        }
      }
    }
    &-graph{
      height: 100%;
      overflow-y: auto;
      & label {
        padding-block: 5px;
        padding-inline: 10px;
        background-color: var(--brand-light-color);
        box-shadow: rgba(17, 17, 26, 0.05) 0px 4px 16px, rgba(17, 17, 26, 0.05) 0px 8px 32px;
        border: .7px solid rgba(30, 30, 30, .2);
        border-radius: 4px;
      }
    }
    }
  }
  .lineCharts {
    // margin-top: 4rem;
    &-single {
      width: 100%;
    }
  }

  .date-range {
    input {
      height: 100%;
      border: .7px solid var(--brand-color);
      border-radius: 4px;
      padding-inline: 4px;
      background: var(--brand-light-color);
    }
  }

  .loader {
    padding: 18rem;
  }
  .selectedMaterial{
    background-color: var(--brand-light-color) !important;
  }
  .hw-100{
    width: 100%;
    height: 100%;
  }
  .apexcharts-zoom-icon ,.apexcharts-zoomout-icon, .apexcharts-zoomin-icon, .apexcharts-zoom-icon, .apexcharts-pan-icon, .apexcharts-menu-icon, .apexcharts-reset-icon {
      width: 25px;  // Adjust the width to increase the size
      height: 25px; // Adjust the height to increase the size
      transform: scale(1) !important;

    }
    .apexcharts-toolbar{
      gap: 7px;
      z-index:3!important;
    }
    .toggle {
  font-size: 1em;
  padding: 0.5em 1.2em;
  color: var(--black);
  font-weight: 500;
  border: none;
  box-shadow: 0.1em 0.1em 0.1em rgba(0, 0, 0, 0.25);
  background-color: var(--side-bar-color);

  &:active {
    box-shadow: inset 0.2em 0.2em 0.2em rgba(0, 0, 0, 0.25);
  }
  &-selected {
    background-color: var(--brand-color);
  }
}
select{
          padding: 10px;
          border: 0.1px solid #dcd8d8;
          border-radius: 8px;
        }
  </style>
